// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__279Gv","actionsCol":"EnrolledClinics_actionsCol__3_Jxx"};